"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.radioboxStylesDark = exports.radioboxStyles = exports.radioInnerCircleDark = exports.radioInnerCircle = exports.labelStylesDark = exports.labelStyles = void 0;

var _reactEmotion = require("react-emotion");

var _styleConsts = require("../utils/styleConsts");

var antRadioEffect =
/*#__PURE__*/
(0, _reactEmotion.keyframes)("0%{-webkit-transform:scale(1);transform:scale(1);opacity:0.5;}100%{-webkit-transform:scale(1.6);transform:scale(1.6);opacity:0;}");

var radioCircleHover = function radioCircleHover(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("&::before{content:'';display:inline-block;position:absolute;width:25px;height:25px;background-color:", theme.color.dark.white0_12, ";transition:0.5s ease;border-radius:50%;top:50%;left:50%;transform:translate(-50%,-50%);}")
  );
};

var inputCheckAnimate =
/*#__PURE__*/
(0, _reactEmotion.css)("position:absolute;top:0;left:0;width:100%;height:100%;border-radius:50%;border:1px solid #1890ff;content:'';-webkit-animation:", antRadioEffect, " 0.36s ease-in-out;animation:", antRadioEffect, " 0.36s ease-in-out;-webkit-animation-fill-mode:both;animation-fill-mode:both;visibility:visible;box-sizing:border-box;");

var labelStyles = function labelStyles(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:", _styleConsts.font.size.large, ";color:", theme.color.black1, ";line-height:18px;cursor:pointer;display:flex;align-items:center;&:hover div{border:1px solid ", theme.color.accent, ";}input{", _styleConsts.screenReaderOnly, "}input:hover ~ span{color:", theme.color.black1, ";}input:checked ~ span{color:", theme.color.black1, ";}input:checked ~ div{position:relative;}input:checked ~ div:after{", inputCheckAnimate, ";}input:checked ~ div{border-color:", theme.color.accent, ";position:relative;span{background-color:", theme.color.accent, ";}}input:disabled ~ span{opacity:", theme.disabledOpacity, ";color:", theme.color.black3, ";}input:disabled ~ div{opacity:", theme.disabledOpacity, ";border:1px solid ", theme.color.black3, ";}")
  );
};

exports.labelStyles = labelStyles;

var labelStylesDark = function labelStylesDark(theme, showDarkBackground) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:", _styleConsts.font.size.medium, ";color:", theme.color.dark.copper, ";", showDarkBackground &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("background:", theme.color.dark.saturn, ";padding:10px;width:fit-content;"), "\n  font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.36;letter-spacing:normal;display:flex;align-items:center;cursor:pointer;&:hover div{", radioCircleHover(theme), ";}input{", _styleConsts.screenReaderOnly, "}input:hover ~ span{color:", theme.color.dark.amethyst, ";}input:checked ~ span{color:", theme.color.dark.amethyst, ";}input:checked ~ div{position:relative;}input:checked ~ div:after{", inputCheckAnimate, ";}input:checked ~ div{border-color:", theme.color.dark.amethyst, ";position:relative;span{background-color:", theme.color.dark.amethyst, ";}}input:disabled ~ span{opacity:", theme.disabledOpacity, ";color:", theme.color.dark.nickel, ";}input:disabled ~ div{opacity:", theme.disabledOpacity, ";border:1px solid ", theme.color.dark.nickel, ";}")
  );
};

exports.labelStylesDark = labelStylesDark;

var radioInnerCircle = function radioInnerCircle(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("width:12px;height:12px;border-radius:50%;background-color:", theme.color.white, ";transition:background-color 0.25s;")
  );
};

exports.radioInnerCircle = radioInnerCircle;

var radioInnerCircleDark = function radioInnerCircleDark() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("width:8px;height:8px;border-radius:50%;background-color:transparent;transition:background-color 0.25s;")
  );
};

exports.radioInnerCircleDark = radioInnerCircleDark;
var alignItems =
/*#__PURE__*/
(0, _reactEmotion.css)("display:inline-flex;justify-content:center;align-items:center;");

var radioboxStyles = function radioboxStyles(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)(alignItems, ";box-sizing:border-box;min-width:18px;max-width:18px;width:18px;height:18px;border:1px solid ", theme.color.black3, ";border-radius:50%;transition:border-color 0.25s;background-color:", theme.color.white, ";margin-right:16px;")
  );
};

exports.radioboxStyles = radioboxStyles;

var radioboxStylesDark = function radioboxStylesDark(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)(alignItems, ";position:relative;box-sizing:border-box;min-width:14px;max-width:14px;width:14px;height:14px;border:1px solid ", theme.color.dark.iron, ";border-radius:50%;transition:border-color 0.25s;background-color:transparent;margin-right:8px;&:hover{", radioCircleHover(theme), ";}")
  );
};

exports.radioboxStylesDark = radioboxStylesDark;